module.exports = __webpack_public_path__ + "img/kong1.4822e29e.png";